import dashjs, {MediaPlayer} from 'dashjs';
import {connect} from 'react-redux';
import {EpicPlayerComponent, browserCheck} from '../EpicPlayer';
import {mapMessageStateToProps} from '../../../../message/Message';
import WithFullScreen from '../../../../../hocs/with-fullscreen/WithFullScreen';
import {appActions} from '../../../../../redux/actions';
import {TrackingEventTypes} from '../../../../../constants/Tracking';

/**
 * dash.js player component
 *
 * @class DashPlayerComponent
 * @extends EpicPlayerComponent
 * @see https://github.com/Dash-Industry-Forum/dash.js
 * @see https://www.npmjs.com/package/dashjs
 */
export class DashPlayerComponent extends EpicPlayerComponent {
    launcherMaxBitrateKbps = 2000;

    constructor(props) {
        super(props);
        console.debug('constructor', 'constructed', props);
        /**
         * Exactly one DASH manifest is possible and supported
         *
         * TODO: Improperly formatted source issues should be caught and thrown
         * e.g. props.sources.length > 0, !props.sources[0].src, !props.sources[0].type, etc
         */

        this.state = {
            ...this.state,
            recipe: props.recipe
        };

        /**
         * Create a dash.js MediaPlayer instance
         *
         * @see http://cdn.dashjs.org/latest/jsdoc/module-MediaPlayer.html
         */
        this.player = MediaPlayer().create();

        /**
         * Gets an instance of the dash.js logging class and sets the log level
         * to something that should produce errors. Not clear presently if the
         * default is NONE or not, so, at minimum this creates a place to adjust
         * log verbosity.
         *
         * TODO: Evaluate environment and ensure logging is off in production builds
         *
         * @see http://cdn.dashjs.org/latest/jsdoc/module-MediaPlayer.html#getDebug
         * @see http://cdn.dashjs.org/latest/jsdoc/module-Debug.html#setLogLevel
         *   dashjs.Debug.LOG_LEVEL_NONE -- No message is written in the browser console.
         *   dashjs.Debug.LOG_LEVEL_FATAL -- Log fatal errors. An error is considered fatal
         *                                   when it causes playback to fail completely.
         *   dashjs.Debug.LOG_LEVEL_ERROR -- Log error messages.
         *   dashjs.Debug.LOG_LEVEL_WARNING -- Log warning messages.
         *   dashjs.Debug.LOG_LEVEL_INFO -- Log info messages.
         *   dashjs.Debug.LOG_LEVEL_DEBUG -- Log debug messages.
         */
        //this.player.getDebug().setLogLevel(dashjs.Debug.LOG_LEVEL_DEBUG);

        this._bindEvents();
    }

    async componentDidMount() {
        super.componentDidMount();
        this.retrieveAndSetSource();
    }

    /**
     * Bind all dash.js MediaPlayer events
     * @private
     */
    _bindEvents = () => {
        this.player.on(dashjs.MediaPlayer.events.SOURCE_INITIALIZED, e =>
            this._onSourceInitialized(e)
        );
    };

    /**
     * Emitted event after MediaPlayer source is initialized
     *
     * @event MediaPlayerEvents#SOURCE_INITIALIZED
     * @see http://cdn.dashjs.org/latest/jsdoc/MediaPlayerEvents.html#event:SOURCE_INITIALIZED
     * @private
     */
    _onSourceInitialized = () => {
        this.player.setAutoSwitchQualityFor('video', true);
        if (browserCheck('launcher')) {
            this.player.setMaxAllowedBitrateFor('video', this.launcherMaxBitrateKbps);
        }
    };

    renderSources(sources) {
        return null;
    }

    /**
     * Get the source URL from Media Service and initialize the DASH.js player with it.
     */
    async retrieveAndSetSource() {
        await this.retrieveMediaData(this.state.recipe.mediaRefId);
        /**
         * Initialize the MediaPlayer instance while passing a Video element reference,
         * attaching a video manifest source URL, and optionally enabling auto-play.
         *
         * @see http://cdn.dashjs.org/latest/jsdoc/module-MediaPlayer.html#initialize
         */
        if (this.isMounted) {
            this.player.initialize(
                this.video,
                this.specificMediaData.manifest.url,
                this.props.autoplay
            );
        }
    }
}

const mapDispatchToProps = {
    trackEvent: params =>
        appActions.trackEvent(
            TrackingEventTypes.Interaction,
            'LauncherVideoPlayer',
            params.eventAction,
            params.eventLabel,
            params.eventValue
        )
};

export default connect(
    mapMessageStateToProps,
    mapDispatchToProps,
    null,
    /**
     * This is required by Redux so we can access the ref within the connected component.
     * @see: https://react-redux.js.org/api/connect#forwardref-boolean
     */
    {forwardRef: true}
)(WithFullScreen(DashPlayerComponent));
